import { Star } from "lucide-react";

export default function StarRating({ value = 0, onChange, size = 18, readOnly = false, testId = "star-rating" }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testId}>
      {stars.map((s) => {
        const filled = s <= Math.round(value);
        return (
          <button
            type="button"
            key={s}
            data-testid={`${testId}-${s}`}
            disabled={readOnly}
            onClick={() => !readOnly && onChange?.(s)}
            className={`p-0.5 ${readOnly ? "" : "hover:scale-110"} transition-transform`}
            aria-label={`${s} stars`}
          >
            <Star
              size={size}
              className={filled ? "fill-[#DDA74F] stroke-[#DDA74F]" : "stroke-[#D1CFC7]"}
            />
          </button>
        );
      })}
    </div>
  );
}
